import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import SubscriptionsTable from "components/Doobi/Subscriptions";
import SubscriptionPaymentsTable from "components/Doobi/SubscriptionPayments";
import SubscriptionOrdersReportTable from "components/Doobi/SubscriptionOrdersReport";

const SubscriptionRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Subscriptions" />
    <BrowserRouter>
    <Switch>
    <Route path={`${match.path}/orders-report`} component={SubscriptionOrdersReportTable}/>
      <Route path={`${match.path}/payment/:id`} component={SubscriptionPaymentsTable}/>
      <Route path={`${match.path}/`} component={SubscriptionsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default SubscriptionRoute;
